import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { TypesButton } from '../../../constants/ButtonTypes';
import { SizesButton } from '../../../constants/SizeButton';
import { units } from '../../../helpers/styles/units';
import { TextEditor } from '../../../components/TextEditor';
import { FontWeight } from '../../../constants/Styles/fontWeight';
import { Button } from '../../../components/Button';
import { UploadPhotoWithMiniature } from '../../../components/UploadPhotoWithMiniature';
import { UploadFile } from '../../../types/Endpoints/files/FilesContract';
import { TypesIcon } from '../../../types/TypesIcon';
import { Icon } from '../../../components/Icon';
import { TextAndImageContract } from '../../../types/Endpoints/blog/BlogCRUDContracts';
import { addModal } from '../../../actions/modal';
import { getId } from '../../../helpers/generateId';
import { TypesModal } from '../../../types/TypesModalComponent';

const StyledMainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(12)};

  max-width: ${units(322)};
  width: 100%;
`;

const StyledTextEditor = styled(TextEditor)`
  & > p {
    margin-bottom: ${units(8)};
    
    font-weight: ${FontWeight.MEDIUM};
  }

  & .ql-toolbar.ql-snow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: ${units(28)};
    padding: 6px 16px;

    border-radius: 0px;
    border-color: #c7c7c7;
  }

  & .ql-snow .ql-editor h3 {
    text-align: center;
  }

  & .ql-container.ql-snow {
    border-radius: 0px;
    border-color: #c7c7c7;

    & .ql-editor {
      min-height: ${units(28)};
      padding: 16px 24px;
    }
  }
`;

const StyledDeleteButton = styled(Button)`
  width: fit-content;
`;

export const TextImageBlock = ({
    updateTextImageBlock,
    deleteTextImageBlock,
    item,
}: {
    updateTextImageBlock: (text: string, image: UploadFile, order: number, id: number) => void
    deleteTextImageBlock: (order: number) => void
    item: TextAndImageContract<UploadFile> & { image?: UploadFile },
}): JSX.Element => {
    const {
        order, text, blogTextAndImageFileId, image, id,
    } = item;
    const dispatch = useDispatch();

    const onChangeValue = (_field: string, value: string) => {
        updateTextImageBlock(value, blogTextAndImageFileId ?? {}, order, id || 100);
    };
    const onChangeImage = (_field: string, value?: UploadFile): void => {
        if (!value) return;
        updateTextImageBlock(text, value ?? {}, order, id || 100);
    };

    return (
        <StyledMainWrapper>
            <StyledTextEditor
                onChange={onChangeValue}
                valueEditor={text}
                name="blogTextAndImageItem"
                title="Текст и изображение"
                withoutPictures={false}
            />
            <UploadPhotoWithMiniature
                name={`headerImageMobileFileTextAndImageItem${Math.random()}`}
                format="3:1"
                onChange={onChangeImage}
                value={image}
                maxSize={2}
            />
            <StyledDeleteButton
                typeButton={TypesButton.DELETE}
                size={SizesButton.M}
                onClick={() => {
                    dispatch(
                        addModal({
                            id: getId()(),
                            type: TypesModal.CONFIRM,
                            message: {
                                description:
                                'Вы действительно хотите удалить?',
                            },
                            onSuccessMessage: 'Удалить',
                            onSuccess: () => deleteTextImageBlock(order),
                            withCloseIcon: true,
                        }),
                    );
                }}
            >
                <Icon
                    type={TypesIcon.TRASH_BIG}
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                />
                Удалить раздел
            </StyledDeleteButton>
        </StyledMainWrapper>
    );
};
